import React, { useCallback, useEffect, useState } from "react";
import { getTimeDelta, useCurrentCase } from "duck";
import { CreateFifteenMinModal, CreateFiveMinModal } from "./components";

const MonitoringTimerModals: React.FC = () => {
  const { procedures } = useCurrentCase(medicalCase => ({
    procedures: medicalCase.data.client?.patient?.patientProcedures
  }));
  const anesthesia = procedures?.find(
    procedure => procedure.name === "Anesthesia"
  );
  const [time, setTime] = useState(() =>
    getTimeDelta(anesthesia?.startTime, anesthesia?.endTime)
  );
  const [showFiveMinModal, setShowFiveMinModal] = useState(false);
  const [showFifteenMinModal, setShowFifteenMinModal] = useState(false);

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined;

    if (anesthesia?.startTime && !anesthesia?.endTime) {
      interval = setInterval(() => {
        setTime(getTimeDelta(anesthesia?.startTime, anesthesia?.endTime));
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [anesthesia?.startTime, anesthesia?.endTime]);

  useEffect(() => {
    const visibilityChangeHandler = () => {
      if (document.visibilityState === "visible") {
        setTime(getTimeDelta(anesthesia?.startTime, anesthesia?.endTime));
      }
    };

    document.addEventListener("visibilitychange", visibilityChangeHandler);

    return () => {
      document.removeEventListener("visibilitychange", visibilityChangeHandler);
    };
  }, [anesthesia?.startTime]);

  useEffect(() => {
    if (time && !anesthesia?.endTime) {
      if (Math.floor(time / 60) % 15 === 0 && time % 60 === 0) {
        setShowFiveMinModal(false);
        setShowFifteenMinModal(false);
        setTimeout(() => {
          setShowFifteenMinModal(true);
        }, 0);
      } else if (Math.floor(time / 60) % 5 === 0 && time % 60 === 0) {
        setShowFifteenMinModal(false);
        setShowFiveMinModal(false);
        setTimeout(() => {
          setShowFiveMinModal(true);
        }, 0);
      }
    }
  }, [time, anesthesia?.endTime]);

  const closeFiveMin = useCallback(() => setShowFiveMinModal(false), []);
  const closeFifteenMin = useCallback(() => setShowFifteenMinModal(false), []);

  return (
    <>
      {showFiveMinModal && <CreateFiveMinModal onClose={closeFiveMin} />}
      {showFifteenMinModal && (
        <CreateFifteenMinModal onClose={closeFifteenMin} />
      )}
    </>
  );
};

export default MonitoringTimerModals;
